export default __webpack_public_path__ + "static/media/bureau.99240d97.png";